import productUtils from '@/core/productUtils'
import CurveData from '@/core/curveData'
import Utils from '@/core/utils'

const convertFluidValue = Utils.timesValue
const state = {
  productId: null,
  // 是否有 风量-全压 或者 流量-扬程 的拟合曲线公式，有才会展示曲线拟合区域
  hasFormula: false,
  detail: {},
  // 处理后展示在页面的产品参数
  parameters: [],
  // 原始的产品参数
  originProperties: [],
  relatedComponents: [],
  relatedBlocks: [],
  performanceHeaderX: {},
  performanceHeaderYs: [],
  performanceData: [],
  // 接口原始的曲线数据
  originCurveData: [],
  // 需求点
  needData: [],
  // 运行点
  operateData: [],
  // 工况相似抛物线
  parabolas: [],
  // 调节曲线相关信息（水泵特有）
  speedRegulate: {},
  // 默认的调速比例、运行点、抛物线等信息
  originWorkCondition: {},
  powerConsumptionPerAirVolume: null,
  performancePropHeader: [],
  performancePropData: [],
  category: null, // fan pump  其他code
  isFluidMeterUnit: false // 水泵如果路由中流量单位是L/s的话为true
}
const getters = {
  detail: (state) => state.detail,
  hasFormula: (state) => state.hasFormula,
  parameters: (state) => {
    const map = new Map()
    state.parameters.forEach((p) => {
      // 根据type设置展示值
      if (p.type === 'Range') {
        if (!p.value1 && !p.value2) {
          p.showValue = ''
        } else if (!p.value1 && (p.value2 || p.value2 === 0)) {
          p.showValue = `≤${p.value2}${p.unitSymbol ? p.unitSymbol : ''}`
        } else if (!p.value2 && (p.value1 || p.value1 === 0)) {
          p.showValue = `≥${p.value1}${p.unitSymbol ? p.unitSymbol : ''}`
        } else {
          p.showValue = `${p.value1}~${p.value2} ${p.unitSymbol ? p.unitSymbol : ''}`
        }
      } else if (p.type === 'Bool') {
        p.showValue = p.value1 === 'true' ? '是' : p.value1 === 'false' ? '否' : ''
      } else if (p.type === 'Enum') {
        if (p.value1) {
          const codes = p.value1.trim().split(',')
          const showValues = codes.reduce((arr, code) => {
            const item = p.values.find((v) => v.code === code)
            if (item) {
              const v = p.unitSymbol ? `${item.name}${p.unitSymbol}` : item.name
              arr.push(v)
            }
            return arr
          }, [])
          p.showValue = showValues.length ? showValues.join(',') : ''
        } else {
          p.showValue = ''
        }
      } else {
        if (!p.value1 && p.value1 !== 0) {
          p.showValue = ''
        } else {
          p.showValue = `${p.value1} ${p.unitSymbol ? p.unitSymbol : ''}`
        }
      }
      // 根据groupCode进行分组
      let values
      const group = map.get(p.groupCode)
      if (group) {
        values = [...group.parameterValues, p]
      } else {
        values = [p]
      }
      map.set(p.groupCode, {
        name: p.groupName,
        parameterValues: values
      })
    })
    return [...map.values()]
  },
  performanceData: (state) => state.performanceData,
  performanceHeaderX: (state) => state.performanceHeaderX,
  performanceHeaderYs: (state) => state.performanceHeaderYs,
  relatedComponents: (state) => state.relatedComponents,
  relatedBlocks: (state) => state.relatedBlocks,
  powerConsumptionPerAirVolume: (state) => state.powerConsumptionPerAirVolume,
  curveData: (state) => {
    const { originCurveData, needData, parabolas, operateData, speedRegulate, powerConsumptionPerAirVolume } = state
    const hasFormulaCurve = originCurveData.filter((item) => item.hasFormula)
    const type = state.detail.gjwCategoryCode ? productUtils.judgeCategory(state.detail.gjwCategoryCode) : ''
    const curve = new CurveData(hasFormulaCurve, needData, parabolas, operateData, speedRegulate, type, powerConsumptionPerAirVolume)
    return curve.getCurveData()
  },
  needData: (state) => state.needData,
  originWorkCondition: (state) => state.originWorkCondition,
  goodsProperties: (state) => {
    const handledProps = []
    const propsPool = state.originProperties
    for (let i = 0, l = propsPool.length; i < l; i++) {
      // 处理 originProperties 为价格查询使用
      const oldProp = propsPool[i]
      const newProp = {
        code: oldProp.code,
        id: oldProp.id,
        name: oldProp.name,
        type: oldProp.type
      }
      if (oldProp.type === 'Enum') {
        if (oldProp.value1) {
          const code = oldProp.value1.trim().split(',')[0]
          const item = Array.isArray(oldProp.values) ? oldProp.values.find((v) => v.code === code) : null
          newProp.value = item ? item.name : null
        } else {
          newProp.value = null
        }
        newProp.values = oldProp.values
      } else if (oldProp.type === 'Range') {
        newProp.value = oldProp.value1 || oldProp.value2 ? `${oldProp.value1}-${oldProp.value2}` : null
      } else {
        newProp.value = oldProp.value1
      }
      handledProps.push(newProp)
    }
    return handledProps
  },
  category: (state) => state.category,
  isFluidMeterUnit: (state) => state.isFluidMeterUnit,
  performancePropHeader: (state) => state.performancePropHeader,
  performancePropData: (state) => state.performancePropData
}
const mutations = {
  setProductId(state, id) {
    state.productId = id
  },
  setDetail(state, data) {
    state.detail = data
    state.category = productUtils.judgeCategory(state.detail.gjwCategoryCode)
  },
  setParameters(state, data) {
    const isFluidMeterUnit = state.isFluidMeterUnit
    if (isFluidMeterUnit) {
      state.parameters = data.reduce((acc, d) => {
        if (['P000007', 'P000083', 'P000084'].includes(d.code)) {
          acc.push({
            ...d,
            value1: convertFluidValue(d.value1, 1 / 3.6, 2),
            unitSymbol: 'L/s'
          })
        } else {
          acc.push(d)
        }
        return acc
      }, [])
    } else {
      state.parameters = data
    }
  },
  setOriginProperties(state, data) {
    state.originProperties = data
  },
  setOriginCurveData(state, data) {
    state.originCurveData = data
  },
  setPerformance(state, response) {
    const headerX = {}
    const headerYs = []
    const table = []
    const iLength = response.length
    const category = state.category
    // 风机水泵才有拟合曲线
    if ((category === 'fan' || category === 'pump' || !category || category === 'VFWaterSupply') && iLength) {
      headerX.name = response[0].axisNameX
      headerX.unit = response[0].unitX
    } else {
      state.hasFormula = false
    }
    state.performanceHeaderX = headerX
    let speedArr = []
    for (let i = 0; i < iLength; i++) {
      const res = response[i]
      // 若特定曲线有公式，则展示【拟合曲线】区域
      if (['PCD-F01', 'PCD-F01-01', 'PCD-F01-02', 'PCD-PP01', 'PCD-VWS01'].includes(res.curveCode) && res.hasFormula) {
        state.hasFormula = true
      }
      const yName = res.axisNameY
      if (!headerYs.some((y) => y.prop === yName)) {
        headerYs.push({ prop: yName, unit: res.unitY })
      }
      const speed = res.curvePropertyDefinitions.find((d) => d.code === 'PCD-P01' || d.code === 'PCD-P08').value
      if (!speedArr.some((s) => s === speed)) {
        speedArr.push(speed)
      }
      const jLength = res.points.length
      for (let j = 0; j < jLength; j++) {
        const value = res.points[j]
        // 不需要显示延长点
        if (value.type === 'EXTEND') { continue }
        const existedIndex = table.findIndex((t) => t.speed === speed && t.valueX === value.valueX)
        if (existedIndex < 0) {
          const obj = { speed, valueX: value.valueX }
          obj[yName] = value.valueY
          table.push(obj)
        } else {
          table[existedIndex][yName] = value.valueY
        }
      }
    }
    state.performanceHeaderYs = headerYs
    // 处理转速排序
    speedArr = speedArr.sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
    // 处理相同转速的valuex排序
    state.performanceData = speedArr.reduce((arr, speed) => {
      let items = table.filter((t) => t.speed === speed)
      if (items.length) {
        items = items.sort((a, b) => a.valueX > b.valueX ? 1 : a.valueX < b.valueX ? -1 : 0)
        items.forEach((item, i) => {
          item.index = i + 1
          arr.push(item)
        })
      }
      return arr
    }, [])
  },
  setRelatedComponents(state, data) {
    state.relatedComponents = data
  },
  setRelatedBlocks(state, data) {
    state.relatedBlocks = data
  },
  setOperatingData(state, data) {
    state.operateData = data
  },
  setNeedData(state, data) {
    state.needData = data
  },
  setParabolas(state, data) {
    state.parabolas = data
  },
  setSpeedRegulate(state, data) {
    state.speedRegulate = data
  },
  setOriginWorkCondition(state, data) {
    state.originWorkCondition = data
  },
  setPowerConsumptionPerAirVolume(state, data) {
    state.powerConsumptionPerAirVolume = data
  },
  updateIsFluidMeterUnit(state, val) {
    state.isFluidMeterUnit = val
  },
  setPerformanceProperties(state, response) {
    const iLength = response.length
    const headers = []
    const table = []
    for (let i = 0; i < iLength; i++) {
      const res = response[i]
      const code = res.code
      const operatingPoint = res.operatingPoint
      const corePerformanceValue = res.corePerformanceValue || ''
      const name = res.name
      const unitSymbol = res.unitSymbol
      const value = res.value
      const sort = res.sort
      if (!headers.some((m) => m.code === code)) {
        const header = {}
        header.code = code
        header.name = name
        header.unitSymbol = unitSymbol
        header.value = value
        header.sort = sort || 0
        headers.push(header)
      }
      const data = table.find((f) => f.speed === corePerformanceValue && f.index === operatingPoint)
      if (data !== undefined) {
        data.data.push({ code, value, sort })
      } else {
        const tableData = {}
        tableData.speed = corePerformanceValue
        tableData.index = operatingPoint
        tableData.data = [{ code, value, sort }]
        table.push(tableData)
      }
    }
    headers.sort((a, b) => {
      return a.sort - b.sort
    })
    table.forEach((item) => {
      item.data.sort((a, b) => {
        return a.sort - b.sort
      })
      item.data.map((data) => {
        item[data.code] = data.value
      })
    })
    table.sort((a, b) => {
      if (a.speed < b.speed) return -1
      if (a.speed > b.speed) return 1
      if (a.index < b.index) return -1
      if (a.index > b.index) return 1
      return 0
    })
    state.performancePropHeader = headers
    state.performancePropData = table
  }
}
const actions = {
  async loadDetail({ commit, state }) {
    try {
      const data = await this.$api.products.detail(state.productId)
      commit('setDetail', data || {})
    } catch (error) {
      commit('setDetail', {})
      console.error(error)
    }
  },
  async loadProperties({ commit, state }) {
    try {
      const data = await this.$api.products.properties(state.productId)
      commit('setParameters', data || [])
      commit('setOriginProperties', data || [])
    } catch (error) {
      commit('setParameters', [])
      commit('setOriginProperties', [])
      console.error(error)
    }
  },
  // 获取曲线性能点
  async loadCurveData({ commit, state }) {
    try {
      const curveData = await this.$api.products.curveData(state.productId)
      // 获取曲线数据就需要把单位和值转换掉
      const isFluidMeterUnit = state.isFluidMeterUnit
      if (isFluidMeterUnit && Array.isArray(curveData)) {
        curveData.forEach((curve) => {
          if (curve) {
            curve.unitX = 'L/s'
            curve.points && curve.points.forEach((p) => {
              p.valueX = convertFluidValue(p?.valueX, 1 / 3.6, 2)
            })
            curve.fittingPoints && curve.fittingPoints.forEach((f) => {
              f.valueX = convertFluidValue(f?.valueX, 1 / 3.6, 2)
            })
          }
        })
      }
      commit('setOriginCurveData', curveData || [])
      commit('setPerformance', curveData || [])
    } catch (error) {
      commit('setOriginCurveData', [])
      commit('setPerformance', [])
      console.error(error)
    }
  },
  // 获取需求点、运行点、调节曲线、单位风量耗功率
  async loadOperatingData({ commit, state, getters, dispatch }, { rate, needPoints, first }) {
    try {
      const isFluidMeterUnit = state.isFluidMeterUnit
      const condition = needPoints.map((item) => {
        let value = item.value
        if (isFluidMeterUnit && item.code === 'P000007') {
          value = convertFluidValue(value, 3.6, 2)
        }
        return { code: item.code, value }
      })
      if (rate || first) {
        const data = await this.$api.products.operateData(state.productId, { rate, condition })
        // 获取产品公开曲线和运行点就需要把单位和值转换掉 intersectionPoints workConditionCurves speedRegulate
        const { intersectionPoints, workConditionCurves, speedRegulate, powerConsumptionPerAirVolume } = data

        commit('setPowerConsumptionPerAirVolume', powerConsumptionPerAirVolume)
        if (first) {
          commit('setOriginWorkCondition', data || {})
        }
        if (isFluidMeterUnit) {
          intersectionPoints.forEach((d) => {
            d.unitX = 'L/s'
            d.valueX = convertFluidValue(d.valueX, 1 / 3.6, 2)
          })
          workConditionCurves.forEach((d) => {
            const needPoints = d.needPoints
            if (needPoints && needPoints.length) {
              needPoints[0] = convertFluidValue(needPoints[0], 1 / 3.6, 2)
            }
            // 特别注意此处的K值有变化，不能使用之前的k
            d.valueK = d.valueK * 3.6 * 3.6
          })
          const { curves, intersectionPoints: intersectionPointsRegulate } = speedRegulate
          curves && curves.length && curves.forEach((c) => {
            c.unitX = 'L/s'
            const points = c.points
            if (points && points.length) {
              points.forEach((p) => { p.valueX = convertFluidValue(p.valueX, 1 / 3.6, 2) })
            }
          })
          intersectionPointsRegulate && intersectionPointsRegulate.length && intersectionPointsRegulate.forEach((ip) => {
            ip.unitX = 'L/s'
            ip.valueXDefault = ip.valueX // 保留原始的valueX，以供选中使用
            ip.valueX = convertFluidValue(ip.valueX, 1 / 3.6, 2)
          })
        }
        commit('setOperatingData', intersectionPoints || [])
        commit('setParabolas', workConditionCurves || [])
        commit('setSpeedRegulate', { originRate: getters.originWorkCondition.speedRegulate ? getters.originWorkCondition.speedRegulate.rate : null, ...speedRegulate })
      } else {
        const { intersectionPoints, workConditionCurves, speedRegulate } = getters.originWorkCondition
        commit('setOperatingData', intersectionPoints || [])
        commit('setParabolas', workConditionCurves || [])
        commit('setSpeedRegulate', { originRate: speedRegulate ? speedRegulate.rate : null, ...speedRegulate })
      }
    } catch (error) {
      commit('setNeedData', needPoints)
      commit('setOperatingData', [])
      commit('setParabolas', [])
      commit('setSpeedRegulate', {})
      console.error(error)
    }
  },
  async loadRelatedComponents({ commit, state, rootState }) {
    try {
      const query = rootState.platform !== 'web'
        ? { software_code: rootState.softwareCode, software_version: rootState.softwareVersion }
        : {}
      const data = await this.$api.products.relatedComponents(state.productId, query)
      localStorage.setItem('relatedComponents', JSON.stringify(data))
      commit('setRelatedComponents', data || [])
    } catch (error) {
      commit('setRelatedComponents', [])
    }
  },
  async loadRelatedBlocks({ commit, state }) {
    try {
      const data = await this.$api.products.relatedBlocks(state.productId)
      commit('setRelatedBlocks', data || [])
    } catch (error) {
      commit('setRelatedBlocks', [])
    }
  },
  async loadPerformanceProperties({ commit, state }) {
    try {
      const data = await this.$api.products.getPerformanceProperties(state.productId)
      commit('setPerformanceProperties', data || [])
    } catch (error) {
      commit('setPerformanceProperties', [])
      console.error(error)
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
